import { Box, Divider, ThemeProvider } from '@mui/material';
import { ReactNode } from 'react';
import { lightActions } from 'src/colors';
import { useSettingsStore } from 'src/store/settings-store';
import { createCustomTheme } from 'src/theme';

interface Props {
  children: ReactNode;
  actionsSlot: ReactNode;
}

const AuthFormWrapper = ({ children, actionsSlot }: Props) => {
  const settingsDirection = useSettingsStore(state => state.direction);

  const theme = createCustomTheme({
    direction: settingsDirection,
    theme: 'light',
  });

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          backgroundColor: 'black',
        }}>
        <Box
          sx={{
            width: '400px',
            background: 'white',
            borderRadius: 0.5,
          }}>
          <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
            {children}
          </Box>
          <Divider sx={{ borderColor: lightActions.disabledBackground }} />
          <Box
            sx={{
              p: 4,
              pt: 0,
              display: 'flex',
              justifyContent: 'flex-end',
              mt: 3,
            }}>
            {actionsSlot}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default AuthFormWrapper;
